<template>
  <PlacePage :place="place" />
</template>

<script setup lang="ts">
import { captureError } from '~/lib/logger'
import type { LanguageCodes } from '~/types/api'

definePageMeta({
  layout: 'search-with-footer'
})

const { locale } = useI18n()

const { getPlacesApiClient } = useApiClients()
const $config = useRuntimeConfig()
const { getRoutePlaceInfo } = usePlaceTransformation()
const routePlaceInfo = computed(() => getRoutePlaceInfo())

const getDefaultPlace = async () => {
  const { data: searchResponse } = await getPlacesApiClient().GET('/Search', {
    params: {
      query: {
        Latitude: $config.public.app.defaultLatitude,
        Longitude: $config.public.app.defaultLongitude,
        PageSize: 1,
        LanguageCode: locale.value as LanguageCodes
      }
    }
  })

  return searchResponse?.results?.[0]
}

const { error: placeError, data: place } = await useAsyncData('place', async () => {
  let placeResponse: any
  const { data: response, error: fetchError } = await getPlacesApiClient().GET('/{route}', {
    params: {
      path: {
        route: routePlaceInfo.value.basePath
      },
      query: {
        languageCode: locale.value as LanguageCodes
      }
    }
  })
  placeResponse = response
  if (fetchError && (fetchError.value || fetchError.title)) {
    placeResponse = await getDefaultPlace()
  }

  return placeResponse
})

if (placeError.value) captureError(toRaw(placeError.value) ?? new Error('Error fetching data for places!'))
</script>
